// /**
//  * XHR Service - Reusable XMLHttpRequest utility
//  */

// class XHRService {
//   constructor(config = {}) {
//     this.baseURL = config.baseURL || "";
//     this.defaultHeaders = config.headers || {};
//     this.timeout = config.timeout || 300000;
//   }

//   request(config) {
//     const {
//       method = "GET",
//       url,
//       params = {},
//       data = null,
//       headers = {},
//       timeout = this.timeout,
//       onProgress = null,
//       onUploadProgress = null,
//     } = config;

//     return new Promise((resolve, reject) => {
//       const xhr = new XMLHttpRequest();

//       // Build full URL
//       const fullURL = this.buildURL(url, params);
//       xhr.open(method, fullURL, true);

//       // Set headers
//       const allHeaders = { ...this.defaultHeaders, ...headers };
//       Object.keys(allHeaders).forEach((key) => {
//         xhr.setRequestHeader(key, allHeaders[key]);
//       });

//       // Set timeout
//       xhr.timeout = timeout;

//       // Download progress
//       if (onProgress) {
//         xhr.onprogress = (event) => {
//           const progress = {
//             loaded: event.loaded,
//             total: event.total,
//             percentage: event.lengthComputable
//               ? (event.loaded / event.total) * 100
//               : null,
//           };
//           onProgress(progress);
//         };
//       }

//       // Upload progress
//       if (onUploadProgress && xhr.upload) {
//         xhr.upload.onprogress = (event) => {
//           const progress = {
//             loaded: event.loaded,
//             total: event.total,
//             percentage: event.lengthComputable
//               ? (event.loaded / event.total) * 100
//               : null,
//           };
//           onUploadProgress(progress);
//         };
//       }

//       // Success
//       xhr.onload = () => {
//         if (xhr.status >= 200 && xhr.status < 300) {
//           try {
//             const response = JSON.parse(xhr.responseText);
//             resolve(response);
//           } catch (error) {
//             reject(new Error(`Parse error: ${error.message}`));
//           }
//         } else {
//           reject(new Error(`HTTP ${xhr.status}: ${xhr.statusText}`));
//         }
//       };

//       // Error handlers
//       xhr.onerror = () => reject(new Error("Network error"));
//       xhr.ontimeout = () => reject(new Error(`Timeout after ${timeout}ms`));

//       // Send request
//       if (data) {
//         xhr.send(JSON.stringify(data));
//       } else {
//         xhr.send();
//       }
//     });
//   }

//   buildURL(url, params) {
//     const fullURL = this.baseURL + url;

//     if (Object.keys(params).length === 0) {
//       return fullURL;
//     }

//     const searchParams = new URLSearchParams();
//     Object.keys(params).forEach((key) => {
//       const value = params[key];
//       searchParams.append(
//         key,
//         typeof value === "object" ? JSON.stringify(value) : value,
//       );
//     });

//     return `${fullURL}?${searchParams.toString()}`;
//   }

//   get(url, config = {}) {
//     return this.request({ ...config, method: "GET", url });
//   }

//   post(url, data, config = {}) {
//     return this.request({ ...config, method: "POST", url, data });
//   }

//   put(url, data, config = {}) {
//     return this.request({ ...config, method: "PUT", url, data });
//   }

//   delete(url, config = {}) {
//     return this.request({ ...config, method: "DELETE", url });
//   }
// }

// // Create default instance
// const xhr = new XHRService({
//   baseURL: "https://api.innque.com/v1/collections",
//   headers: {
//     "Content-Type": "application/json",
//     Accept: "application/json",
//     "X-Application-Id": "bc29547f-8ffd-4221-9d70-d4e68c158623",
//     "X-Session-Token": "bd53767a-3521-45a5-a4f1-65657c8c8047",
//   },
//   timeout: 300000,
// });

// // Export both the class and default instance
// export { XHRService };
// export default xhr;

class XHRService {
  constructor(config = {}) {
    this.baseURL = config.baseURL || "";
    this.defaultHeaders = config.headers || {};
    this.timeout = config.timeout || 300000;
  }

  request(config) {
    const {
      method = "GET",
      url,
      params = {},
      data = null,
      headers = {},
      timeout = this.timeout,
      onProgress = null,
      onChunk = null,
      signal = null, // NEW: AbortSignal support
    } = config;

    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      const fullURL = this.buildURL(url, params);
      xhr.open(method, fullURL, true);

      const allHeaders = { ...this.defaultHeaders, ...headers };
      Object.keys(allHeaders).forEach((key) => {
        xhr.setRequestHeader(key, allHeaders[key]);
      });

      xhr.timeout = timeout;

      // NEW: Handle abort signal
      if (signal) {
        if (signal.aborted) {
          xhr.abort();
          reject(new DOMException("Aborted", "AbortError"));
          return;
        }

        signal.addEventListener("abort", () => {
          xhr.abort();
          reject(new DOMException("Aborted", "AbortError"));
        });
      }

      let lastIndex = 0;
      let buffer = "";

      xhr.onprogress = (event) => {
        const progress = {
          loaded: event.loaded,
          total: event.total,
          percentage: event.lengthComputable
            ? (event.loaded / event.total) * 100
            : null,
        };

        if (onProgress) {
          onProgress(progress);
        }

        if (onChunk && xhr.responseText) {
          try {
            const responseText = xhr.responseText;

            if (responseText.startsWith("[")) {
              const newText = responseText.substring(lastIndex);
              buffer += newText;

              const chunks = this.extractCompleteObjects(buffer);

              if (chunks.length > 0) {
                onChunk(chunks);
                buffer = this.cleanBuffer(buffer, chunks);
              }

              lastIndex = responseText.length;
            }
          } catch (e) {
            // Continue waiting for more data
          }
        }
      };

      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            const response = JSON.parse(xhr.responseText);
            resolve(response);
          } catch (error) {
            reject(new Error(`Parse error: ${error.message}`));
          }
        } else {
          reject(new Error(`HTTP ${xhr.status}: ${xhr.statusText}`));
        }
      };

      xhr.onerror = () => reject(new Error("Network error"));
      xhr.ontimeout = () => reject(new Error(`Timeout after ${timeout}ms`));
      xhr.onabort = () => reject(new DOMException("Aborted", "AbortError"));

      if (data) {
        xhr.send(JSON.stringify(data));
      } else {
        xhr.send();
      }
    });
  }

  extractCompleteObjects(text) {
    const objects = [];
    let depth = 0;
    let objStart = -1;

    for (let i = 0; i < text.length; i++) {
      const char = text[i];

      if (char === "{") {
        if (depth === 0) objStart = i;
        depth++;
      } else if (char === "}") {
        depth--;
        if (depth === 0 && objStart !== -1) {
          try {
            const objText = text.substring(objStart, i + 1);
            const obj = JSON.parse(objText);
            objects.push(obj);
            objStart = -1;
          } catch (e) {
            // Not a complete object yet
          }
        }
      }
    }

    return objects;
  }

  cleanBuffer(buffer, processedObjects) {
    let cleaned = buffer;
    processedObjects.forEach((obj) => {
      const objStr = JSON.stringify(obj);
      cleaned = cleaned.replace(objStr, "");
    });
    return cleaned;
  }

  buildURL(url, params) {
    const fullURL = this.baseURL + url;

    if (Object.keys(params).length === 0) {
      return fullURL;
    }

    const searchParams = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      const value = params[key];
      searchParams.append(
        key,
        typeof value === "object" ? JSON.stringify(value) : value,
      );
    });

    return `${fullURL}?${searchParams.toString()}`;
  }

  get(url, config = {}) {
    return this.request({ ...config, method: "GET", url });
  }

  post(url, data, config = {}) {
    return this.request({ ...config, method: "POST", url, data });
  }
}

const xhr = new XHRService({
  baseURL: "https://api.innque.com/v1/collections",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "X-Application-Id": "bc29547f-8ffd-4221-9d70-d4e68c158623",
    // "X-Session-Token": "bd53767a-3521-45a5-a4f1-65657c8c8047",
    "X-Master-key": "77e27f20-2a6c-4b7b-b44e-1356c6d69768",
  },
  timeout: 300000,
});

export default xhr;

// class XHRService {
//   constructor(config = {}) {
//     this.baseURL = config.baseURL || "";
//     this.defaultHeaders = config.headers || {};
//     this.timeout = config.timeout || 300000;
//   }

//   request(config) {
//     const {
//       method = "GET",
//       url,
//       params = {},
//       data = null,
//       headers = {},
//       timeout = this.timeout,
//       onProgress = null,
//       onChunk = null, // Real-time chunk callback
//     } = config;

//     return new Promise((resolve, reject) => {
//       const xhr = new XMLHttpRequest();

//       const fullURL = this.buildURL(url, params);
//       xhr.open(method, fullURL, true);

//       const allHeaders = { ...this.defaultHeaders, ...headers };
//       Object.keys(allHeaders).forEach((key) => {
//         xhr.setRequestHeader(key, allHeaders[key]);
//       });

//       xhr.timeout = timeout;

//       let lastIndex = 0;
//       let buffer = "";

//       // IMPORTANT: Enable access to partial response
//       xhr.onprogress = (event) => {
//         const progress = {
//           loaded: event.loaded,
//           total: event.total,
//           percentage: event.lengthComputable
//             ? (event.loaded / event.total) * 100
//             : null,
//         };

//         if (onProgress) {
//           onProgress(progress);
//         }

//         // Stream chunks during download
//         if (onChunk && xhr.responseText) {
//           try {
//             const responseText = xhr.responseText;

//             // Try to parse incrementally
//             // Most JSON APIs return array: [item1, item2, ...]
//             if (responseText.startsWith("[")) {
//               // Find complete objects in the stream
//               const newText = responseText.substring(lastIndex);
//               buffer += newText;

//               // Try to extract complete JSON objects
//               const chunks = this.extractCompleteObjects(buffer);

//               if (chunks.length > 0) {
//                 onChunk(chunks);
//                 // Clear processed part from buffer
//                 buffer = this.cleanBuffer(buffer, chunks);
//               }

//               lastIndex = responseText.length;
//             }
//           } catch (e) {
//             // Continue waiting for more data
//           }
//         }
//       };

//       xhr.onload = () => {
//         if (xhr.status >= 200 && xhr.status < 300) {
//           try {
//             const response = JSON.parse(xhr.responseText);
//             resolve(response);
//           } catch (error) {
//             reject(new Error(`Parse error: ${error.message}`));
//           }
//         } else {
//           reject(new Error(`HTTP ${xhr.status}: ${xhr.statusText}`));
//         }
//       };

//       xhr.onerror = () => reject(new Error("Network error"));
//       xhr.ontimeout = () => reject(new Error(`Timeout after ${timeout}ms`));

//       if (data) {
//         xhr.send(JSON.stringify(data));
//       } else {
//         xhr.send();
//       }
//     });
//   }

//   // Extract complete JSON objects from stream
//   extractCompleteObjects(text) {
//     const objects = [];
//     let depth = 0;
//     let objStart = -1;

//     for (let i = 0; i < text.length; i++) {
//       const char = text[i];

//       if (char === "{") {
//         if (depth === 0) objStart = i;
//         depth++;
//       } else if (char === "}") {
//         depth--;
//         if (depth === 0 && objStart !== -1) {
//           try {
//             const objText = text.substring(objStart, i + 1);
//             const obj = JSON.parse(objText);
//             objects.push(obj);
//             objStart = -1;
//           } catch (e) {
//             // Not a complete object yet
//           }
//         }
//       }
//     }

//     return objects;
//   }

//   cleanBuffer(buffer, processedObjects) {
//     // Remove processed objects from buffer
//     let cleaned = buffer;
//     processedObjects.forEach((obj) => {
//       const objStr = JSON.stringify(obj);
//       cleaned = cleaned.replace(objStr, "");
//     });
//     return cleaned;
//   }

//   buildURL(url, params) {
//     const fullURL = this.baseURL + url;

//     if (Object.keys(params).length === 0) {
//       return fullURL;
//     }

//     const searchParams = new URLSearchParams();
//     Object.keys(params).forEach((key) => {
//       const value = params[key];
//       searchParams.append(
//         key,
//         typeof value === "object" ? JSON.stringify(value) : value,
//       );
//     });

//     return `${fullURL}?${searchParams.toString()}`;
//   }

//   get(url, config = {}) {
//     return this.request({ ...config, method: "GET", url });
//   }

//   post(url, data, config = {}) {
//     return this.request({ ...config, method: "POST", url, data });
//   }
// }

// const xhr = new XHRService({
//   baseURL: "https://api.innque.com/v1/collections",
//   headers: {
//     "Content-Type": "application/json",
//     Accept: "application/json",
//     "X-Application-Id": "bc29547f-8ffd-4221-9d70-d4e68c158623",
//     "X-Session-Token": "bd53767a-3521-45a5-a4f1-65657c8c8047",
//   },
//   timeout: 300000,
// });

// export default xhr;
